window.onload = function(e){ 
  
  async function collectionColor() {
    try {
      setTimeout(function(){
        // console.log('collectionColor Init:');
        var allElements = document.getElementsByClassName('js-grid-item')
        
        for (var index = 0; index < allElements.length; index++) {
          var element = allElements[index];

          if (element.getElementsByClassName('js-other-colors')[0]) {
          var otherColors = element.getElementsByClassName('js-other-colors')[0]
            var selectorWrapperScrollbar = element.getElementsByClassName('js-selector-wrapper-scrollbar')[0]
            var colorScript = otherColors.getElementsByTagName("script")[0].textContent
            if (typeof(colorScript) != 'undefined' || colorScript != null) {
              var colorJson = JSON.parse(colorScript) || [] 
              if (colorJson.length > 1) {
                selectorWrapperScrollbar.innerHTML = ''
                colorJson.forEach(option => {
                  var val = option.variants[0].option2
                  var varID = option.variants[0].id
                  var valHandle = val.toLowerCase().replaceAll(' ','-')
                    
                  selectorWrapperScrollbar.innerHTML += `<div class="swatches swatch__button swatch__button--square swatch-${valHandle}" data-swatch-button="" data-tooltip="${val}" data-swatch-variant="${varID}" data-swatch-variant-name="${option.variants[0].title}" data-swatch-image="" data-variant="${varID}" style="--animation-delay: 0s; --swatch: var(--${valHandle});">
                    <a class="swatch__link" data-swatch-link="" href="/products/${option.handle}?variant=${varID}" data-swatch="${val}">${val}</a>
                  </div>`
                })

                element.classList.add('hide-data-swatch-count')
                element.getElementsByClassName('js-data-swatch-count')[0].innerHTML = colorJson.length + ' colors'

              }
            }
          }
        }
      },500)

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  collectionColor();

  setInterval(function () {
    collectionColor()
  }, 2000);


}